import { createBrowserRouter } from 'react-router-dom';
import Layout from '@/components/layout/layout/Layout';
import Dashboard from '@/page/dashboard/Dashboard';
import Login from '@/page/login/Login';
import AlertSample from '@/page/sample/alert/AlertSample';
import ProtectedRoute from '@components/common/Route/ProtectedRoute';
import CorporationList from '@/page/user/corparation/CorporationList';
import WorkerList from '@/page/user/WorkerList';
import FarmerList from '@/page/user/FarmerList';
import CorporationDetail from '@/page/user/corparation/CorporationDetail';
import CorporationAdd from '@/page/user/corparation/CorporationAdd';
import Season from '@/page/growth/season/Season';
import SeasonAdd from '@/page/growth/season/SeasonAdd';
import SeasonDetail from '@/page/growth/season/SeasonDetail';
import Farmland from '@/page/farmland/Farmland';
import StationList from '@/page/weather/station/StationList';
import AreaList from '@/page/weather/area/AreaList';
import AreaAdd from '@/page/weather/area/AreaAdd';
import AreaDetail from '@/page/weather/area/AreaDetail';
import WeatherList from '@/page/weather/weather/WeatherList';
import WeatherScheduleLogList from '@/page/weather/log/WeatherScheduleLogList';
import GrowthDashboard from '@/page/growth/dashboard/GrowthDashboard';

const router = createBrowserRouter([
    {
        path: '/login',
        element: <Login />, // Layout 없이 렌더링
    },
    {
        path: '/',
        element: (
            <ProtectedRoute>
                <Layout />
            </ProtectedRoute>
        ),
        children: [
            {
                index: true, // 기본 경로에서 렌더링
                element: <Dashboard />,
            },
            {
                path: 'dashboard',
                element: <Dashboard />,
            },
            {
                path: 'corporation',
                element: <CorporationList />,
            },
            {
                path: 'corporation/:userIdx', // 동적 경로 추가
                element: <CorporationDetail />,
            },
            {
                path: 'corporation/add', // 동적 경로 추가
                element: <CorporationAdd />,
            },
            {
                path: 'season',
                element: <Season />,
            },
            {
                path: 'season/add',
                element: <SeasonAdd />,
            },
            {
                path: 'season/:gsIdx',
                element: <SeasonDetail />,
            },
            {
                path: 'farmland/:gsIdx?',
                element: <Farmland />,
            },
            {
                path: 'growth/dashboard',
                element: <GrowthDashboard />,
            },
            {
                path: 'worker',
                element: <WorkerList />,
            },
            {
                path: 'farmer',
                element: <FarmerList />,
            },
            {
                path: 'sample/alert',
                element: <AlertSample />,
            },
            {
                path: 'weather/station',
                element: <StationList />,
            },
            {
                path: 'weather/area',
                element: <AreaList />,
            },
            {
                path: 'weather/area/add',
                element: <AreaAdd />,
            },
            {
                path: 'weather/area/:areaIdx',
                element: <AreaDetail />,
            },
            {
                path: 'weather',
                element: <WeatherList />,
            },
            {
                path: 'weather/log',
                element: <WeatherScheduleLogList />,
            },
        ],
    },
]);

export default router;
